<div>
  <div class="text-xs mb-10 space-y-2">
    <p>Utilize o formulário abaixo para fazer a alteração dos seus dados pessoais.</p>
    <p>O seu nome ficará disponível nos eventos criados como também nas solicitações de contacto.</p>
  </div>

  <form method="POST" class="space-y-4" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="space-y-8">

      <!-- firstname -->
      <div>
        <app-text-input [formGroup]="form" id="firstname" placeholder="Primeiro Nome" [maxLength]="25"
                        [value]="form.value?.firstname" label="Primeiro Nome"
                        [formError]="formErrors?.get('firstname')"></app-text-input>
      </div>

      <!-- lastname -->
      <div>
        <app-text-input [formGroup]="form" id="lastname" placeholder="Último Nome" [maxLength]="25"
                        [value]="form.value?.lastname" label="Último Nome"
                        [formError]="formErrors.get('lastname')"></app-text-input>
      </div>

    </div>

    <hr>

    <!-- submit button -->
    <div class="flex justify-end">
      <app-ae-button variant="primary" label="Editar Dados pessoais" [disabled]="!form.valid" [loading]="isLoading"
                (buttonClick)="onSubmit()" size="sm" styleClass="justify-end"></app-ae-button>
    </div>
  </form>
</div>
